<header>
  <img src="/assets/img/logo.svg" alt="CRST logo" class="crst-logo" />
  <h1 class="mat-display-large">Track Your Shipment</h1>
</header>
<main>
  <router-outlet />
</main>
<footer>
  <p class="mat-body-small">&copy; {{ year }} CRST Inc.</p>
</footer>
